import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import UploadedImageRow from '../shared/UploadedImageRow';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const CircleUploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
}) => {
  return (
    <UploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showText={false}
      showSettings={false}
      showPreview={false}
      circularImage
      imgRatioX={61}
      imgRatioY={61}
    />
  );
};

export default memo(CircleUploadedImageRow);
